<template>

  <CenterWrapper>
    <ContentFrame>

      <PageTitle>
        Next
      </PageTitle>
      <div class="progressTitle">progress</div>

      <div class="progress">

        <!-- into own component -->
        <!-- if n in history -->
        <div
          v-for="n in $store.state.completions.length"
          class="progressChunk progressCompleted"
          >
        </div>
        <div
          v-for="n in (250 - $store.state.completions.length)"
          class="progressChunk progressIncomplete"
          >
        </div>
      </div>

      <!-- Video tutorial template -->
      <div v-if="$store.state.step.type == 'video'">
        <LessonCard>
          <div
            class="videoThumbContainer"
            v-bind:style="{ backgroundImage: `url(${$store.state.step.thumbnail})` }"
            >
          </div>
          <div class="videoInfo">
            <div class="videoTitle">
              {{$store.state.step.name}}
            </div>

            <div class="description">
              {{$store.state.step.description}}
            </div>
            <div class="videoMeta">

            </div>

          </div>
          <div class="ctaStepContainer">
            <LessonCTA
              v-on:click="open"
              >

              <div>Start</div>
            </LessonCTA>
            <LessonCTA
              v-on:click="completeStep"
              >
              <div>Done</div>
            </LessonCTA>
            <div class="videoStep">
            <!-- nothin here, used to be 1 of 7 -->
            </div>

          </div>
        </LessonCard>

      </div>

      <!-- quiz template -->
      <div v-else-if="$store.state.step.type == 'reflection'">
        <div class="demo-card-event mdl-card mdl-shadow--2dp">
          <!--Descrtiption -->
          <h4>
            {{$store.state.step.description}}
          </h4>
          <!--Multiple choice -->
          <ul id="answers">
            <div v-for="item in $store.state.step.stepMeta.qandA">
              {{item.question}}
              <li v-for="choice in item.choices">
                <button @click="checkAnswer(choice , item.rightAns)" type="checkbox">
                  {{choice}}
                </button>
              </li>
            </div>
          </ul>
          <!-- Done button to continue to the next lesson/quiz -->
          <a @click="completeStep" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Done
            <i class="material-icons">check_circle_outline</i>
          </a>
          <!-- Back button to return to the previous lesson
          <a @click="previousStep" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            Back
          </a>
          -->
        </div>
      </div>

      <!-- Decision template -->
      <div v-else-if="$store.state.step.type == 'decision'">



      <!-- decisions -->
      <LessonCard v-for="decision in $store.state.step.stepMeta.decisions">

        <div
          class="videoThumbContainer"
          v-bind:style="{ backgroundImage: `url(${decision.thumbnail})` }"
          >
        </div>
        <div class="videoInfo">
          <div class="videoTitle">
            {{decision.title}}
          </div>

          <div class="description">
            {{decision.description}}
          </div>

          <div class="videoMeta">
            <div>{{decision.estimatedTime}}</div>
            <div>{{decision.numberOfSteps}}  Lessons</div>
          </div>

        </div>
        <div class="ctaDecisionContainer">
          <LessonCTA
            v-on:click="setChain(decision)"
            >

            <div>Begin</div>
          </LessonCTA>
        </div>

      </LessonCard>
    </div>

    </ContentFrame>
  </CenterWrapper>
</template>


<script>
  import data from '../data'
  import VideoView from './VideoView.vue'
  import Practice from './Practice.vue'
  import { getUser } from '../utils/battles-api'
  import { showPayment } from '../utils/misc'

  export default {
    methods: {

      test() {
        alert("Test")
      },

      //Cheking if the users answer is true or false.
      checkAnswer(choice, correctAnswer) {
        //Checks if choice is equal to the correct answer.
        //If correct the lesson will continue, if false the user will recieve a prompt to return to the previous video.
        if (choice === correctAnswer) {
          alert("That answer is correct! Let's move on!")
          this.completeStep()
        } else {
          alert("That was incorrect, would you like to try again?")
          this.previousStep()
        }
      },

      // Assumes no loaded step
      getNextStep() {
        this.$store.commit('getNextStep')
      },
      getCompletions(){
        this.$store.commit('getCompletions')
      },
      completeStep() {
        this.$store.commit('completeStep', this.$store.state.step)
        this.$store.commit('getCompletions')
      },

      // NOTE : previousStep decisionDescrtiptiont always work, if coming from decision
      // leaving out for now
      previousStep() {
        this.$store.commit('previousStep', this.$store.state.step)
      },
      setChain(decision) {
        this.$store.commit('setChain', decision)
      },

      open() {
        this.$modal.show(
          VideoView, {
            adaptive: true,
          }, {
            width: "80%",
            height: "80%"
          }
        )
      },
      getUser() {
        getUser().then((user) => {
          // Set user
          // if user is unpaid, reset to begin route for payment
          this.$store.commit('setUser', user)

          //if (!user.payment || user.payment.duration == 0) {
          if (showPayment(user)) {
            this.$router.push({ path: '/' })
          }

        }).catch((error) => {
          console.log(error)
          // alert("error")
        })
      }
    },
    mounted() {
      this.getUser()
      this.getNextStep()
      this.getCompletions()

    },
    data() {
      return {}
    }
  }
</script>

<style scoped>

.description{
  color: #444444;
  font-size: 14px;
  line-height: 133.4%;
}
.videoThumbContainer{
  width: 227px;
  height: 141px;
  background-size: cover;
}
/* UGLY, needs an explicit style for mobile
three div row layout not great
*/
@media (max-width: 600px) {
  .videoThumbContainer{
    width: 141px;
    height: 141px;
    background-position: center;
    background-size: cover;
  }
}


.ctaDecisionContainer{
  height: 141px;
  margin-left: auto;
  padding-right: 21px;
  display: flex;
  /*
  justify-content: flex-end;
  */
  flex-direction: column;
  justify-content: space-between;
}

.ctaStepContainer{
  height: 100px;
  margin-left: auto;
  padding-right: 21px;
  display: flex;
  /*
  justify-content: flex-end;
  */
  flex-direction: column;
  justify-content: space-between;
}

@media (max-width: 600px) {
  .ctaStepContainer{
    height: 70px;
    margin-left: auto;
    padding-right: 10px;
  }
  .ctaDecisionContainer{

  }
}
.videoStep{
  font-size: 39px;
}
.videoInfo{
  font-family: 'Roboto', sans-serif;

  width: 313px;
  display: flex;
  flex-direction: column;
  height: 141px;
  justify-content: space-between;
  padding-left: 21px; /* same as left pad of LessonCard */
}

@media (max-width: 600px) {
  .videoInfo{
    width: 250px;
  }
}

.videoTitle{
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  /* identical to box height */
  color: #444444;
}

.videoMeta{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 50%;

  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.115em;

  text-transform: uppercase;
  color: #444444;
}

.progressTitle{
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.2em;
  color: #676666;
  text-transform: uppercase;
}
.progress{
  width: 100%;
  height: 82px;
  display: flex;
  flex-flow: column;
  flex-wrap: wrap;
  align-content: flex-stretch;
  padding:1.5px;
}

.progressChunk{
  width: 12px;
  height: 12px;
  margin: 1.5px;
}

.progressIncomplete{
  background: #E2E2E2;
}

.progressCompleted{
  background: #B2E325;
}

@media (max-width: 600px) {
  .progressChunk{
    width: 8px;
    height: 8px;
    margin: 1.0px;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/HomeView.vue